import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

// Handoff REPORTS waiting on a manager, in the daily Task list (CJ 2026-09-30:
// "if i acknowledge it in my daily tasks it should also acknowledge it in the
// handoff issues tab").
//
// The Task list already showed hand-off NOTES — closer-to-opener messages,
// acknowledged by whoever reads them — and a report acknowledged nowhere
// visible from here. This card acks the report record itself, through the
// same endpoint the Handoff reports tab uses, so it reads acknowledged in
// both places. Renders nothing when there is nothing waiting.
export function HandoffReportsDue({ currentUser }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  const [rows, setRows] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api('GET', '/api/admin/shift-handoff/unacknowledged', null, headers)
      .then((r) => setRows(r?.reports || []))
      .catch((e) => setMsg(e?.message || 'Could not load handoff reports'));
  }, [currentUser.id]); // eslint-disable-line react-hooks/exhaustive-deps

  async function ack(id) {
    setBusyId(id); setMsg('');
    try {
      await api('POST', `/api/admin/shift-handoff/${id}/acknowledge`, {}, headers);
      setRows((rs) => rs.filter((r) => r.id !== id));
    } catch (e) { setMsg(e?.message || 'Could not acknowledge that'); }
    finally { setBusyId(null); }
  }

  const open = () => window.dispatchEvent(new CustomEvent('monarch:navigate', { detail: 'reports-handoff' }));

  if (rows.length === 0 && !msg) return null;

  return (
    <div className="card" style={{ borderLeft: '4px solid #a55c33' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <div className="text-base font-semibold">Handoff reports to acknowledge</div>
        <span style={{ fontSize: 11.5, fontWeight: 700, color: '#a55c33' }}>{rows.length} waiting</span>
        <button onClick={open} className="btn-secondary"
                style={{ marginLeft: 'auto', fontSize: 11.5, whiteSpace: 'nowrap' }}>
          Open reports
        </button>
      </div>
      <div style={{ fontSize: 12, color: '#757575', marginTop: 3 }}>
        The person who reported it can see when a manager acknowledges.
      </div>
      {msg && <div className="text-xs text-red-700" style={{ marginTop: 6 }}>{msg}</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 7, marginTop: 9 }}>
        {rows.map((r) => (
          <div key={r.id} style={{ border: '1px solid #eee', borderRadius: 8, padding: '9px 11px',
                                   borderLeft: `3px solid ${r.severity === 'high' ? '#c62828' : '#a55c33'}` }}>
            <div style={{ fontSize: 13, fontWeight: 700 }}>
              {r.location_name} — {r.shift_date} {r.handoff_shift_kind || 'shift'}
            </div>
            <div style={{ fontSize: 12.5, color: '#212121', marginTop: 3 }}>
              {(r.items || []).map((i) => i.label + (i.note ? ` — ${i.note}` : '')).join(' · ')}
            </div>
            <div style={{ fontSize: 11, color: '#757575', marginTop: 3 }}>
              Reported by {r.reporter_name || 'a team member'}
              {r.photo_count > 0 ? ` · ${r.photo_count} photo${r.photo_count === 1 ? '' : 's'}` : ''}
            </div>
            <button onClick={() => ack(r.id)} disabled={busyId === r.id} className="btn-primary"
                    style={{ marginTop: 8, fontSize: 11.5 }}>
              {busyId === r.id ? '…' : 'Acknowledge'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
